import { useSearchParams, Link } from 'react-router-dom';
import { CadeAvatar } from '../components/CadeAvatar';

// Landing screen shown after a "Sign in with Microsoft" attempt from an
// Entra tenant that has no IdpConfig yet — the auth service routes the
// attempt into the SignupRequest approval queue and returns
// `{ status: 'request_created' }`. Spec:
// docs/spec/topics/auth/ms-sso-signup-request.md (Reqs 674-678).
//
// URL params (set by useAuth.initAuth and loginWithSso):
//   - e (email)          : the requester's email from the Entra token
//   - p (alreadyPending) : "1" when the SSO intake helper deduped to an
//                          existing pending row, "0" otherwise.
//
// Falls back gracefully if params are missing (deep-link / refresh): renders
// the generic copy without the email.

export function AccessRequestedPage() {
  const [params] = useSearchParams();
  const email = params.get('e') ?? undefined;
  const alreadyPending = params.get('p') === '1';

  return (
    <div className="login-container">
      <div className="login-card" style={{ gap: 18 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
          <CadeAvatar size={80} />
          <span className="login-logo-text">Cade</span>
        </div>
        {email && (
          <p style={{
            margin: 0, padding: '8px 12px', textAlign: 'center', fontSize: 12,
            color: 'var(--color-text-primary)', background: 'var(--color-bg-secondary)',
            border: '1px solid var(--color-border)', borderRadius: 6,
          }}>
            <span aria-hidden="true" style={{ color: 'var(--color-accent)', marginRight: 6 }}>✓</span>
            Signed in to Microsoft as <strong>{email}</strong>
          </p>
        )}
        <h1 style={{ fontSize: 20, margin: '8px 0 0', textAlign: 'center' }}>
          {alreadyPending
            ? 'Your Cade trial request is already in the queue.'
            : 'Request trial access to start using Cade.'}
        </h1>
        <p style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--color-text-muted)', textAlign: 'center' }}>
          {alreadyPending ? (
            <>
              We already have a pending request for{' '}
              {email ? <strong>{email}</strong> : 'your organization'}. A Cade admin
              will review it within 2–3 business days. When you're approved, we'll email{' '}
              {email ? <strong>{email}</strong> : 'you'} — sign in with Microsoft again
              and you'll land in your new workspace.
            </>
          ) : (
            <>
              Cade is invite-only during private beta. We've just received your trial
              request{email ? <> from <strong>{email}</strong></> : null}. A Cade admin
              will review it within 2–3 business days. When you're approved, we'll email{' '}
              {email ? <strong>{email}</strong> : 'you'} — sign in with Microsoft again
              and you'll land in your new workspace.
            </>
          )}
        </p>
        <Link to="/login" className="btn-link" style={{ textAlign: 'center', marginTop: 8 }}>
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
